// import axios from "axios";

// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// export const API = `${BACKEND_URL}/api`;

// const api = axios.create({
//     baseURL: API,
//     withCredentials: true,
// });

// Attach bearer from localStorage if available (fallback if cookies blocked)
// api.interceptors.request.use((config) => {
//     const token = localStorage.getItem("token");
//     if (token) {
//         config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
// });

const MOCK_PRODUCTS = [
  {
    id: "prod-1",
    name: "Classic Roasted Makhana",
    slug: "classic-roasted",
    description:
      "Light, crunchy fox nuts roasted in the Himalayan pink salt. The purest way to enjoy makhana — rich in protein and guilt-free snacking.",
    flavor: "classic",
    pack_size: "100g",
    price: 249.0,
    original_price: 299.0,
    images: ["https://images.unsplash.com/photo-1660439639799-cf80d7dfda54"],
    ingredients: ["Fox Nuts (Makhana)", "Himalayan Pink Salt", "Sunflower Oil"],
    nutrition: {
      Energy: "347 kcal",
      Protein: "9.7g",
      Carbs: "76g",
      Fat: "0.1g",
      Fiber: "14.5g",
    },
    stock: 200,
    featured: true,
    popularity: 95,
    rating: 4.8,
    reviews_count: 142,
    badges: ["100% Natural", "Air Roasted", "Vegan"],
    reviews: [],
  },
  {
    id: "prod-2",
    name: "Spicy Peri Peri Makhana",
    slug: "peri-peri",
    description:
      "Bold, fiery, unforgettable. Air-roasted makhana tossed in our signature African peri peri blend for the heat-seeker in you.",
    flavor: "peri_peri",
    pack_size: "100g",
    price: 279.0,
    original_price: 329.0,
    images: [
      "https://images.pexels.com/photos/18301125/pexels-photo-18301125.jpeg",
    ],
    ingredients: [
      "Fox Nuts",
      "Peri Peri Mix",
      "Paprika",
      "Garlic",
      "Sunflower Oil",
    ],
    nutrition: {
      Energy: "362 kcal",
      Protein: "9.5g",
      Carbs: "74g",
      Fat: "1.2g",
      Fiber: "14g",
    },
    stock: 150,
    featured: true,
    popularity: 100,
    rating: 4.9,
    reviews_count: 218,
    badges: ["Spicy", "Air Roasted", "No Preservatives"],
    reviews: [],
  },
  {
    id: "prod-3",
    name: "Fresh Pudina Makhana",
    slug: "pudina",
    description:
      "A refreshing burst of mint meets crunchy makhana. Garden-fresh pudina with a tangy twist — hydrating snacking at its finest.",
    flavor: "pudina",
    pack_size: "100g",
    price: 259.0,
    original_price: 299.0,
    images: [
      "https://images.pexels.com/photos/7855271/pexels-photo-7855271.jpeg",
    ],
    ingredients: [
      "Fox Nuts",
      "Dried Mint",
      "Chaat Masala",
      "Black Salt",
      "Sunflower Oil",
    ],
    nutrition: {
      Energy: "352 kcal",
      Protein: "9.6g",
      Carbs: "75g",
      Fat: "0.8g",
      Fiber: "14.2g",
    },
    stock: 180,
    featured: true,
    popularity: 88,
    rating: 4.7,
    reviews_count: 97,
    badges: ["Refreshing", "Air Roasted", "Gluten Free"],
    reviews: [],
  },
  {
    id: "prod-4",
    name: "Dark Chocolate Makhana",
    slug: "chocolate",
    description:
      "Dessert meets wellness. Premium makhana coated in 70% dark chocolate — a sinfully guilt-free indulgence.",
    flavor: "chocolate",
    pack_size: "100g",
    price: 349.0,
    original_price: 399.0,
    images: [
      "https://images.pexels.com/photos/5472169/pexels-photo-5472169.jpeg",
    ],
    ingredients: ["Fox Nuts", "70% Dark Chocolate", "Cocoa", "Organic Jaggery"],
    nutrition: {
      Energy: "412 kcal",
      Protein: "10.2g",
      Carbs: "68g",
      Fat: "12g",
      Fiber: "13.5g",
    },
    stock: 120,
    featured: true,
    popularity: 92,
    rating: 4.9,
    reviews_count: 165,
    badges: ["Indulgent", "Dark Chocolate", "No Refined Sugar"],
    reviews: [],
  },
  {
    id: "prod-5",
    name: "Classic Roasted Makhana (Family Pack)",
    slug: "classic-roasted-200g",
    description:
      "Our bestseller — now in a 200g family pack. Share the crunch (or don't).",
    flavor: "classic",
    pack_size: "200g",
    price: 449.0,
    original_price: 549.0,
    images: ["https://images.unsplash.com/photo-1660439639799-cf80d7dfda54"],
    ingredients: ["Fox Nuts", "Pink Salt", "Sunflower Oil"],
    nutrition: {
      Energy: "347 kcal",
      Protein: "9.7g",
      Carbs: "76g",
      Fat: "0.1g",
      Fiber: "14.5g",
    },
    stock: 80,
    featured: false,
    popularity: 75,
    rating: 4.8,
    reviews_count: 58,
    badges: ["Family Pack", "Best Value"],
    reviews: [],
  },
  {
    id: "prod-6",
    name: "Peri Peri Makhana (Mini Pack)",
    slug: "peri-peri-50g",
    description:
      "Pocket-sized spice. Perfect for on-the-go snacking or office drawers.",
    flavor: "peri_peri",
    pack_size: "50g",
    price: 149.0,
    original_price: 179.0,
    images: [
      "https://images.pexels.com/photos/18301125/pexels-photo-18301125.jpeg",
    ],
    ingredients: ["Fox Nuts", "Peri Peri", "Paprika"],
    nutrition: {
      Energy: "362 kcal",
      Protein: "9.5g",
      Carbs: "74g",
      Fat: "1.2g",
      Fiber: "14g",
    },
    stock: 200,
    featured: false,
    popularity: 70,
    rating: 4.7,
    reviews_count: 41,
    badges: ["Travel Pack", "Spicy"],
    reviews: [],
  },
];

// Mock API with hardcoded responses
const api = {
  get: async (url) => {
    // Simulate network delay
    await new Promise((resolve) => setTimeout(resolve, 300));

    if (url === "/products") {
      return { data: MOCK_PRODUCTS };
    }
    if (url.startsWith("/products/")) {
      const slug = url.split("/").pop();
      const product = MOCK_PRODUCTS.find((p) => p.slug === slug);
      if (product) return { data: product };
      throw new Error("Product not found");
    }
    if (url === "/wishlist") {
      return { data: { user_id: "user-1", product_ids: [] } };
    }
    if (url === "/cart") {
      return { data: { user_id: "user-1", items: [] } };
    }
    if (url === "/auth/me") {
      return { data: null };
    }
    throw new Error("Not found");
  },

  post: async (url, data) => {
    await new Promise((resolve) => setTimeout(resolve, 300));
    if (url === "/auth/login") {
      return {
        data: {
          id: "user-1",
          name: "Test User",
          email: data.email,
          role: "user",
          token: "mock-token",
        },
      };
    }
    if (url === "/auth/register") {
      return {
        data: {
          id: "user-1",
          name: data.name,
          email: data.email,
          role: "user",
          token: "mock-token",
        },
      };
    }
    if (url.startsWith("/cart/add")) {
      return {
        data: {
          user_id: "user-1",
          items: [{ product_id: data.product_id, quantity: data.quantity }],
        },
      };
    }
    if (url.startsWith("/wishlist/toggle")) {
      return { data: { product_ids: [], added: true } };
    }
    throw new Error("Not found");
  },

  put: async (url, data) => {
    await new Promise((resolve) => setTimeout(resolve, 300));
    return { data: { success: true } };
  },

  delete: async (url) => {
    await new Promise((resolve) => setTimeout(resolve, 300));
    return { data: { ok: true } };
  },

  interceptors: {
    request: { use: () => {} },
  },
};

export default api;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
